<template>
  <VLink
    v-if="tender.orderPositions.length === 1"
    class="ellipsis"
    :disabled="$core.currentPartner.isSeller === true && tender.hasOwnOrderPositions === false"
    :title="`${tender.orderPositions[0].id} - ${tender.orderPositions[0].qty.format(tender.unit)}`"
    @click="openPositionCard(tender.orderPositions[0])"
  >
    <!--Удалённая позиция остаётся в списке ссылкой, но красной: заказа по ней больше нет -->
    <span :class="{'critical': tender.orderPositions[0].isDeleted === true}">
      {{ $core.utils.string.formatWithDelimiter(tender.orderPositions[0].id) }} -
      {{ tender.orderPositions[0].qty.format(tender.unit) }}
    </span>
  </VLink>

  <template v-else>
    <VButton
      v-if="$core.utils.isNotEmptyArray(tender.orderPositions) === true"
      theme="link"
      :disabled="$core.currentPartner.isSeller === true && tender.hasOwnOrderPositions === false"
      class="nowrap"
      @click="TendersService.showOrders(tender, $event.currentTarget)"
    >
      Сформировано - {{ tender.orderPositions.length }}
    </VButton>
    <div v-else>
      Нет заказов
    </div>
  </template>
</template>


<script lang="ts">
import TendersService from '@/domains/Tenders/TendersService';
import type Tender from '@/domains/Tenders/Tender';
import type OrderPosition from '@/domains/Orders/OrderPosition';
import {UnwrapNestedRefs} from "vue";

export default defineComponent({
  name: 'TenderOrdersCounter',

  props: {
    /**
     * Тендер целиком: позиции заказов, единица измерения и признак
     * предзаказа — всё лежит в нём, раскладывать по отдельным пропам незачем.
     */
    tender: {
      type:     Object as PropType<Tender | UnwrapNestedRefs<Tender>>,
      required: true,
    },
  },

  setup() {
    return {
      TendersService,
    };
  },

  methods: {
    /** Карточка единственной позиции заказа */
    openPositionCard(position: OrderPosition): Promise<boolean> {
      return TendersService.showOrderPositionCard(position);
    },
  },
});
</script>
